import React, { useState } from 'react';
import { ReactComponent as CloseIcon } from '@blink/assets/src/icons/closeGray.svg';

import { cn } from '@/shared/lib/tailwind-merge';

type GuideInfoProps = {
    visible?: boolean;
};

export const GuideInfo: React.FC<GuideInfoProps> = ({ visible = false }) => {
    const [closed, setClosed] = useState(false);

    return closed ? null : (
        <div
            className={cn(
                'relative mt-8 flex items-center justify-center bg-background-secondary border border-border-opaque p-4 h-16 text-content-primary',
                {
                    hidden: !visible,
                },
            )}
        >
            Get ready to level up your DeFi lending and borrowing game with our comprehensive guide!
            <CloseIcon
                className='absolute right-3 cursor-pointer hover:opacity-100'
                size={20}
                onClick={() => setClosed(true)}
            />
        </div>
    );
};
